// extracted by css-extract-rspack-plugin
var _1 = "b7_SI";
export { _1 as "bodyContainer" }
